<template>
  <div class="fullheight">
    <div class="modal" :class="modal.show ? 'is-active' : ''">
      <div
        class="modal-background"
        style="background-color: rgba(10, 10, 10, 0.33)"
        @click="modal.show = false"
      ></div>
      <div class="modal-card">
        <section
          class="modal-card-body"
          style="border-radius: 5px"
          v-html="modal.html"
        ></section>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="modal.show = false"
      ></button>
    </div>
    <div
      class="modal_reminder modal"
      :class="modal_reminder.show ? 'is-active' : ''"
    >
      <div
        class="modal-background"
        style="background-color: rgba(10, 10, 10, 0.33)"
        @click="closeModalAd"
      ></div>
      <div class="modal-card">
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="closeModalAd"
        ></button>
        <section class="modal-card-body">
          <img
            src="../../src/assets/img/logo_Cardiff.svg"
            id="logo_modal"
            height="71"
            width="320"
            loading="lazy"
          />
          <p class="modal-reminder-title">Don’t leave yet!</p>
          <p class="modal-reminder-subtitle">
            You are 60 seconds away<br />
            from your approval!
          </p>
          <button
            class="modal-reminder-button button is-link padded-button next-button"
            @click="closeModalAd"
          >
            Continue to See Offers
          </button>
        </section>
      </div>
    </div>
    <nav
      class="mobile-only"
      role="navigation"
      aria-label="main navigation"
      :class="affil ? 'navbar-' + affil : 'navbar'"
    >
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px">
            <img
              :src="
                require('@/assets/img/' +
                  affil +
                  '-white-text-only-powered.png')
              "
              id="logo"
              height="28"
              v-if="affil"
              loading="lazy"
            />
            <img
              src="../../src/assets/img/cardiff-white-text-only.png"
              id="logo"
              height="28"
              loading="lazy"
              v-else
            />
          </a>
        </div>
      </div>
    </nav>
    <div
      class="container is-fluid fullheight"
      id="appcontainer"
      v-on:mouseleave="mouseleave($event)"
    >
      <div class="columns fullheight is-centered">
        <div
          class="column is-one-quarter"
          id="cardiff-column"
          v-if="page < 12 || !prod"
        >
          <div
            id="sidebarlogo"
            style="width: 180px; margin: auto; margin-bottom: 20px"
          >
            <img
              :src="require('../../src/assets/img/' + affil + '-square.png')"
              style="border-radius: 10px"
              loading="lazy"
              v-if="affil"
            />
            <img
              src="../../src/assets/img/cardiff-square.png"
              style="border-radius: 10px"
              loading="lazy"
              v-else
            />
            <img
              src="../../src/assets/img/poweredby.png"
              style="border-radius: 3px; margin:0 auto; width: 100px; display: block;"
              loading="lazy"
              v-if="affil"
            />
          </div>
          <h4 class="has-text-centered">
            {{ tags.APP_GREETING }}
          </h4>
          <p class="has-text-centered" style="margin-bottom: 30px">
            {{ tags.APP_SUBHEADING }}
          </p>

          <div style="margin: auto; width: 100%; text-align: center">
            <img
              src="../../src/assets/img/bbb.svg"
              style="max-width: 100px; margin-right: 10px; margin-left: 10px"
              loading="lazy"
            />
            <img
              src="../../src/assets/img/ssl.svg"
              style="max-width: 100px; margin-right: 10px"
              loading="lazy"
            />
          </div>
        </div>
        <div class="column" id="app-column">
          <transition name="slide" mode="out-in">
            <div
              class="tabs is-small is-centered is-fullwidth"
              :class="scrolled ? 'fixed-tabs' : ''"
              v-if="page < 9"
            >
              <ul>
                <li
                  :class="page < 3 ? 'is-active' : ''"
                  style="margin-top: 0px"
                >
                  <a> {{ tags.HEADER_BASIC_INFORMATION }}</a>
                </li>
                <li
                  :class="page > 2 && page < 6 ? 'is-active' : ''"
                  style="margin-top: 0px"
                >
                  <a>Ownership</a>
                </li>
                <li
                  :class="page > 5 ? 'is-active' : ''"
                  style="margin-top: 0px"
                >
                  <a>Finances</a>
                </li>
              </ul>
            </div>
          </transition>
          <div
            id="transition_container"
            style="max-width: 600px; margin: auto"
            :class="scrolled ? 'pushed-pages' : ''"
            v-if="!loading"
          >
            <transition name="slide" mode="out-in">
              <GetStarted
                v-if="page == 0 && !loading"
                key="p0"
                @next="incrementPage"
                :amt="$route.params.amt"
              />
              <PersonalInfoApply
                v-if="page == 1"
                key="p1"
                @next="incrementPage"
              />
              <BusinessInfo v-if="page == 2" key="p2" @next="incrementPage" />
              <IFF
                v-if="page == 3"
                key="p3"
                api="apply"
                @next="incrementPage"
                :link="model.sfleadid"
                :lang="language"
              />
              <VerifyOwnership
                v-if="page == 4"
                key="p4"
                @next="incrementPage"
                :lang="language"
              />
              <!-- <Signature v-if="page == 5" key="p5" @next="incrementPage" /> -->
              <!-- <LoanInfo v-if="page == 6" key="p6" @next="incrementPage" /> -->
              <BankVerify
                v-if="page == 5"
                key="p7"
                @next="incrementPage"
                message="To provide an instant approval, we need to verify your business bank account information."
              />
              <Plaid
                v-if="page == 6"
                key="p8"
                @next="incrementPage"
                api="plaid"
                redirect_url="apply"
              />
              <PlaidResult
                v-if="page == 7"
                key="p9"
                api="apply"
                @next="incrementPage"
                :itemid="item_id"
                @back="page--"
                :link="model.sfleadid"
              />

              <UploadDoc
                v-if="page == 8"
                key="p10"
                @next="incrementPage"
                doc="Photo ID"
                api="apply"
                :link="model.sfleadid"
              />
              <UploadDoc
                v-if="page == 9"
                key="p11"
                @next="incrementPage"
                doc="Voided Check"
                api="apply"
                :link="model.sfleadid"
              />
              <Approval
                v-if="page == 10"
                key="p12"
                title="Congrats!"
                :texts="finishText"
                @next="incrementPage"
              />
            </transition>
          </div>
          <div
            style="max-width: 600px; margin: auto"
            :class="scrolled ? 'pushed-pages' : ''"
            v-if="loading"
          >
            <a
              class="button is-link is-loading is-large is-fullwidth"
              key="loading"
              >Loading</a
            >
          </div>
        </div>
      </div>
    </div>
    <footer
      class="footer mobile-only"
      style="margin-top: 60px"
      v-if="page != 5"
    >
      <div class="content has-text-centered">
        <img
          src="../../src/assets/img/bbb.svg"
          style="margin-left: 15px; max-width: 120px"
          loading="lazy"
        />
        <img
          src="../../src/assets/img/ssl.svg"
          style="margin-left: 15px; max-width: 120px; margin-right: 15px"
          loading="lazy"
        />
        <p style="font-size: 0.675em; color: grey; margin-top: 10px">
          © 2024 Cardiff, Inc
        </p>
      </div>
    </footer>
    <div v-if="!prod && !affil" id="stagingmenu">
      <div style="display: flex">
        <div style="flex: 1; padding-left: 10px">
          <p
            style="
              font-weight: bold;
              font-variant: all-small-caps;
              margin-bottom: 0px;
              text-align: center;
            "
          >
            IFF Staging Menu ({{
              model.sfleadid ? "Lead ID:" + model.sfleadid : "NOT COMMITTED"
            }})
          </p>
          <!-- <ol
            style="margin: 0 !important; font-size: 10pt; padding: 10px; columns: 3; text-align: center;"
          >
            <li :class="page == 1 ? 'listpage-active' : 'listpage'">
              GetStarted
            </li>
            <li :class="page == 2 ? 'listpage-active' : 'listpage'">
              PersonalInfo
            </li>
            <li :class="page == 3 ? 'listpage-active' : 'listpage'">
              BusinessInfo
            </li>
            <li :class="page == 4 ? 'listpage-active' : 'listpage'">
              VerifyOwnership
            </li>
            <li :class="page == 5 ? 'listpage-active' : 'listpage'">
              Signature
            </li>
            <li :class="page == 6 ? 'listpage-active' : 'listpage'">
              LoanInfo
            </li>
            <li :class="page == 7 ? 'listpage-active' : 'listpage'">
              BankVerify
            </li>
            <li :class="page == 8 ? 'listpage-active' : 'listpage'">Plaid</li>
            <li :class="page == 9 ? 'listpage-active' : 'listpage'">
              PlaidResult
            </li>
            <li :class="page == 10 ? 'listpage-active' : 'listpage'">
              UploadDoc
            </li>
            <li :class="page == 11 ? 'listpage-active' : 'listpage'">
              UploadDoc
            </li>
            <li :class="page == 12 ? 'listpage-active' : 'listpage'">
              Approval
            </li>
          </ol> -->

          <div
            style="
              flex: 1;
              display: flex;
              text-align: center;
              align-items: center;
              margin-bottom: 10px;
            "
          >
            <div
              style="
                flex: 1 1 auto;
                cursor: pointer;
                margin: 0 auto;
                max-width: 40px;
                background-color: #276cda;
                border-color: transparent;
                color: #fff;
                border-radius: 5px;
                padding: 5px;
              "
              @click="page > 0 ? page-- : console.log('cant')"
            >
              -
            </div>
            <div style="text-align: center; margin-bottom: 5px">
              Page {{ page }}/{{ maxPage }} ({{
                isMobile() ? "Mobile" : "Desktop"
              }})
            </div>
            <div
              style="
                flex: 1 1 auto;
                cursor: pointer;
                margin: 0 auto;
                max-width: 40px;
                background-color: #276cda;
                border-color: transparent;
                color: #fff;
                border-radius: 5px;
                padding: 5px;
              "
              @click="page < maxPage ? page++ : console.log('cant')"
            >
              +
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/modal_ad.css";
import {
  GetStarted,
  PersonalInfoApply,
  BankVerify,
  BusinessInfo,
  IFF,
  VerifyOwnership,
  // Signature,
  UploadDoc,
  // LoanInfo,
  Plaid,
  PlaidResult,
  Approval,
} from "@/components/apply/pages";
import { build } from "@/tools/modelBuilder";
import CONSTANTS from "@/tools/translations.js";
import $ from "jquery";
import Vue from "vue";

let location = window.location.href;

function setWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

function resetProgress() {
  console.log("resetting progress");
  setWithExpiry("leadid", null, 1);
  window.location.reload();
}

let validate =
  location.indexOf("://cardiff") > -1 || location.indexOf("www.cardiff") > -1;
console.log("validate", validate);
export default {
  name: "ApplyIFF",
  components: {
    GetStarted,
    PersonalInfoApply,
    BankVerify,
    BusinessInfo,
    IFF,
    // Signature,
    UploadDoc,
    // LoanInfo,
    Plaid,
    PlaidResult,
    Approval,
    VerifyOwnership,
  },
  data() {
    return {
      page: 0,
      maxPage: 12,
      demo: false,
      customerId: null,
      item_id: null,
      scrolled: false,
      loading: false,
      plaid: null,
      iff_prefill: null,
      prod: validate,
      modal: {
        show: false,
        shown: false,
        html: "",
      },
      modal_reminder: {
        show: false,
        shown: false,
        html: "",
      },
      // seconds_elapsed: 0,
      utm_app_cta: false,
      marketing_cloud_campaign: "",
      affil: null,
      finishText: [
        { str: "You've successfully applied for financing with Cardiff!" },
        {
          str: "You can now close this page. A representative will contact you if we need any additional information.",
        },
      ],
      model: { sfleadid: null },
      tags: [],
    };
  },
  computed: {},
  methods: {
    mouseleave(event) {
      // console.log(event);
      // console.log("clientY: " + event.clientY);
      // console.log("screenY: " + event.screenY);
      // console.log("offset: " + event.offsetY);
      // console.log("pageY: " + event.pageY);
      if (parseInt(event.clientY) < 50) {
        console.log("should show up the modal window");
        this.modal_reminder.show = true;
      }
    },
    closeModalAd() {
      var self = this;
      self.modal_reminder.show = false;
      // self.seconds_elapsed = 0;
      self.utm_app_cta = true;
    },

    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    incrementPage: function (pageData) {
      var self = this;
      console.log("pageData", pageData);
      this.model = build(this.model, pageData);
      if (pageData.customerId) {
        // console.log("we have the customer id ", pageData.customerId);
        this.customerId = pageData.customerId;
      }
      if (pageData.item_id) {
        this.item_id = pageData.item_id;
        self.plaid = {
          item_id: pageData.item_id,
          access_token: pageData.access_token,
        };
      }

      if (
        pageData &&
        pageData.inputs &&
        pageData.inputs.classification &&
        pageData.inputs.classification.value
      ) {
        setWithExpiry(
          "classification",
          pageData.inputs.classification.value,
          259200
        );
      }
      if (
        pageData &&
        pageData.inputs &&
        pageData.inputs.name &&
        pageData.inputs.name.value
      ) {
        setWithExpiry("company_name", pageData.inputs.name.value, 259200);
      }

      if (
        pageData &&
        pageData.inputs &&
        pageData.inputs.tid &&
        pageData.inputs.tid.value
      ) {
        console.log("found tid");
        setWithExpiry("tid", pageData.inputs.tid.value, 259200);
        setWithExpiry("srfico", pageData.inputs.srfico.value, 259200);
        setWithExpiry("zip", pageData.inputs.zip.value, 259200);
      }
      if (pageData.iff_prefill) {
        self.iff_prefill = pageData.iff_prefill;
        // alert('iff_prefill', JSON.stringify(pageData.iff_prefill))
        self.page = 4; //same page as VerifyOwnership component, or after?
        // console.log(
        //   "iff_prefill page",
        //   "current model",
        //   self.model,
        //   "iff prefill",
        //   pageData.iff_prefill
        // );
        let m = self.model.pg;
        let p = pageData.iff_prefill;
        m.fn = p.fn;
        m.ln = p.ln;
        m.address = p.address;
        m.city = p.city;
        m.state = p.state;
        m.zip = p.zip;
        m.dob = p.dob;
        m.ssn =
          p.ssn.substr(0, 3) +
          "-" +
          p.ssn.substr(3, 2) +
          "-" +
          p.ssn.substr(5, 4);
        m.iff = true;
      }

      //following variables are used to send data to google
      if (window.custom_data == undefined) {
        window.custom_data = {};
        window.custom_data.country = "US";
      }
      if (this.model.business && this.model.business.email !== undefined) {
        window.custom_data.email = this.model.business.email;
        setWithExpiry("email", this.model.business.email, 8000000);
      }
      if (this.model.pg && this.model.pg.fn !== undefined) {
        window.custom_data.first_name = this.model.pg.fn;
        setWithExpiry("first_name", this.model.pg.fn, 8000000);
      }
      if (this.model.pg && this.model.pg.ln !== undefined) {
        window.custom_data.last_name = this.model.pg.ln;
        setWithExpiry("last_name", this.model.pg.ln, 8000000);
      }
      if (this.model.business && this.model.business.address !== undefined) {
        window.custom_data.street = this.model.business.address;
        setWithExpiry("street", this.model.business.address, 8000000);
      }
      if (this.model.business && this.model.business.city !== undefined) {
        window.custom_data.city = this.model.business.city;
        setWithExpiry("city", this.model.business.city, 8000000);
      }
      if (this.model.business && this.model.business.state !== undefined) {
        window.custom_data.state = this.model.business.state;
        setWithExpiry("state", this.model.business.state, 8000000);
      }
      if (this.model.business && this.model.business.zip !== undefined) {
        window.custom_data.postal_code = this.model.business.zip;
        setWithExpiry("postal_code", this.model.business.zip, 8000000);
      }
      if (this.model.business && this.model.business.phone !== undefined) {
        window.custom_data.phone_number = this.model.business.phone;
        let phone_normalized = this.model.business.phone.replace(/[^\d]/g, "");
        console.log(phone_normalized);
        phone_normalized = "+1" + phone_normalized;
        setWithExpiry("phone_number", phone_normalized, 8000000);
      }

      if (
        this.model.business &&
        this.model.business.startMonthNumber &&
        this.model.business.startMonthNumber !== undefined
      ) {
        setWithExpiry(
          "startMonthNumber",
          this.model.business.startMonthNumber,
          8000000
        );
      }

      if (
        this.model.business &&
        this.model.business.startYear &&
        this.model.business.startYear !== undefined
      ) {
        setWithExpiry("startYear", this.model.business.startYear, 8000000);
      }
      if (
        this.model.business &&
        this.model.business.products &&
        this.model.business.products !== undefined
      ) {
        setWithExpiry("products", this.model.business.products, 8000000);
      }
      // console.log(pageData.inputs);
      if (
        pageData &&
        pageData.inputs &&
        pageData.inputs.monthly_sales &&
        pageData.inputs.monthly_sales.value
      ) {
        setWithExpiry(
          "monthly_sales",
          pageData.inputs.monthly_sales.value,
          8000000
        );
      }

      // if (pageData.validate){
      //send the api request
      $.ajax({
        type: "POST",
        url: "/api/apply/lead",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          model: self.model,
          page: self.page,
          utm_app_cta: self.utm_app_cta,
          marketing_cloud_campaign: self.marketing_cloud_campaign,
        }),
      })
        .done(function (response) {
          if (response.leadid) {
            console.log("setting leadid in model", response.leadid);
            self.model.sfleadid = response.leadid;

            //save to local storage
            setWithExpiry("leadid", response.leadid, 259200);
          }
          if (response.page) {
            if (response.page == 2) {
              ttq.load("C443S04787TERR100EAG");

              fbq("track", "CompleteRegistration");
              // dataLayer.push({ event: "Contact Form" });

              window.uetq = window.uetq || [];
              window.uetq.push("event", "contact_filled", {});
            }

            if (response.page == 6) {
              ttq.load("C443S04787TERR100EB0");

              // dataLayer.push({ event: "Complete App" });

              window.uetq = window.uetq || [];
              window.uetq.push("event", "finished_app", {});
            }

            if (response.page == 11) {
            }
          }
        })
        .fail(function (err) {
          console.log(err.responseText);
          self.invalid = true;
        });
      // }

      this.page++;

      let monthly_sales = getWithExpiry("monthly_sales");
      // console.log("monthly_sales: " + monthly_sales);
      // console.log("page: " + self.page);
      let monthly_sales_float = 0;
      if (monthly_sales && monthly_sales != "") {
        monthly_sales_float = parseFloat(monthly_sales.replace(/,/g, ""));
      }

      // if (monthly_sales_float < 10000 && self.page == 3) {
      //we set page 9 but it will convert into page 10 later at the end of the method
      // self.page = 5;
      // self.page = 8;
      // }
      let product_interest_array = getWithExpiry("products");
      let product_type = "WC";
      let product_interest = "";
      if (product_interest_array && product_interest_array.length > 0) {
        product_interest = product_interest_array.toString();
      }
      console.log("product interest array: ", product_interest_array);
      console.log("product interest string: ", product_interest);
      if (
        product_interest == "Equipment Financing" ||
        product_interest == "Vehicle Financing" ||
        product_interest == "Equipment Financing,Vehicle Financing"
      ) {
        product_type = "EF";
      }
      console.log("product type: ", product_type);
      let startMonthNumber = getWithExpiry("startMonthNumber");
      let startYear = getWithExpiry("startYear");

      let months_since_company_start = 0;
      var start_date = startMonthNumber + startYear + "";
      start_date = start_date.trim();

      if (start_date && start_date !== "" && start_date) {
        let dateFrom = new Date(startYear, startMonthNumber);
        let dateTo = new Date();
        months_since_company_start =
          dateTo.getMonth() -
          dateFrom.getMonth() +
          12 * (dateTo.getFullYear() - dateFrom.getFullYear());
      }
      console.log("months in Biz: " + months_since_company_start);

      if (self.page == 3) {
        //IFF for experian
        //monthly sales > 10 y no cumple con EF mandalo insertar los datos de SSN
        //monthly sales < 10 y no cumple con EF mandalo pagina 9
        // if (product_type == "WC" && monthly_sales_float < 10000) {
        //   console.log("wc and <10k");
        //   self.page = 8; //skip asking this user
        // } else if (months_since_company_start <= 18 && product_type == "EF") {
        //   console.log("ef and <=18m");
        //   self.page = 8;
        // }
        // if (product_type == "WC" && monthly_sales_float >= 10000) {
        //   console.log("wc and >10k");
        //   self.page = 4; //add data for owner without running experian
        // } else if (product_type == "WC" && monthly_sales_float < 10000) {
        //   console.log("wc and <10k");
        //   self.page = 8; //skip asking this user
        // } else if (months_since_company_start > 18 && product_type == "EF") {
        //   console.log("ef and >18m");
        //   self.page = 3;
        // } else if (months_since_company_start <= 18 && product_type == "EF") {
        //   console.log("ef and <=18m");
        //   self.page = 8;
        // }
      }

      if (self.page == 5) {
        //monthly sales > 10 y no cumple con EF mandalo insertar los datos de SSN
        //monthly sales < 10 y no cumple con EF mandalo pagina 9
        //no nanofi
        if (product_type == "WC" && monthly_sales_float < 15000) {
          console.log("wc and <10k");
          self.page = 8; //skip asking this user
        }
        if (months_since_company_start <= 18 && product_type == "EF") {
          console.log("ef and <=18m");
          self.page = 8;
        }
        if (
          product_type == "WC" &&
          monthly_sales_float >= 20000 &&
          months_since_company_start > 8
        ) {
          // do nothing, send them to plaid

          console.log("WC and >=20k and > 8m");
        } else if (monthly_sales_float >= 15000) {
          // product_type == "EF" ||
          // (product_type == "WC" &&
          //   months_since_company_start <= 8 &&
          //  )
          // )
          //   (product_type == "WC" &&
          //     monthly_sales_float >= 15000 &&
          //     monthly_sales_float < 20000)
          // )
          console.log(">15k and <20k and <=8m");
          self.page = 8;
        }
        // nano-fi if
        else if (monthly_sales_float < 15000) {
          // start nanofi
          // $("#plaid_ad_container").hide();
          // $("#submit_leads_ad").show();
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 1000);
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 2000);
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 3000);
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 5000);
          // console.log("data sent");
          // $.ajax({
          //   type: "POST",
          //   url: "/api/apply/submit_lead",
          //   contentType: "application/json",
          //   dataType: "json",
          //   data: JSON.stringify({ model: self.model }),
          // }).done(function (response) {
          //   console.log(response);
          //   if (response.link != "") {
          //     console.log("hacemos el redirect"); // $(location).attr("href", response.link);
          //     window.location.replace(response.link);
          //   }
          //   if (response.error) {
          //     console.log(response.message);
          //   }
          // });
          // end nanofi

          // in case nanofi is disabled send this code.
          self.page = 8;
        }
      }

      // self.seconds_elapsed = 0;
      window.scrollTo(0, 0);
      console.log(self.page);
      if (self.page == 5 || self.page == 7) {
        console.log("100%");
        $("#transition_container").css("max-width", "100%");
      } else {
        console.log("600px");
        $("#transition_container").css("max-width", 600);
      }
    },
    scrollListener: function () {
      var scrollTop =
        window.pageYOffset ||
        (document.documentElement || document.body.parentNode || document.body)
          .scrollTop;
      if (scrollTop > 60) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    mouseListener: function (e) {
      var y = window.Event
        ? e.pageY
        : event.clientY +
          (document.documentElement.scrollTop
            ? document.documentElement.scrollTop
            : document.body.scrollTop);
      if (y < 5 && !this.modal.shown) {
        this.modal.show = true;
        this.modal.shown = true;
      }
    },
  },
  created: function () {
    this.language = "en";
    if (this.$route.params.language) {
      this.language = this.$route.params.language;
    }
    var tags = [];
    var language = this.language;
    $.each(CONSTANTS, function (key, value) {
      var translation = value[language];
      tags[key] = value[language];
    });

    this.tags = tags;
    // console.log(this.tags.HEADER_BASIC_INFORMATION);
    Vue.prototype.$language = this.language;
    // this.APP_GREETING = CONSTANTS.APP_GREETING[Vue.prototype.$language]
    // this.APP_SUBHEADING = CONSTANTS.APP_SUBHEADING[Vue.prototype.$language]
    // this.HEADER_BASIC_INFORMATION = CONSTANTS.HEADER_BASIC_INFORMATION[Vue.prototype.$language]
  },
  mounted: function () {
    // $("#transition_container").css("max-width", "100%");
    console.log("v3 - iff");
    atadlauq.atadlauqs(null);
    // const tl_pixel = '272432666998242'

    // if (fbq && fbq.getState() && fbq.getState().pixels && fbq.getState().pixels.length > 0){
    //   console.log(fbq.getState().pixels)
    //   let tl_found = false
    //     fbq.getState().pixels.forEach((pixel) => {
    //       if (pixel && pixel.id && pixel.id == tl_pixel)
    //       tl_found = true

    //       console.log('pixel', pixel)
    //     })

    //     if (!tl_found)
    //     fbq('init', tl_pixel);
    //     else
    //     console.log('not initializing pixel')
    // }

    var self = this;
    document.title = "Apply For a Business Loan Today | Cardiff.co";
    window.addEventListener("scroll", this.scrollListener);
    setTimeout(function () {
      if (window.Event) {
        document.captureEvents(Event.MOUSEMOVE);
      }
      // document.onmousemove = self.mouseListener;
    }, 10000);

    this.scrollListener();

    setWithExpiry("external_id", external_id, 4000000);

    // console.log(self.$route.query);
    if (self.$route.query.fbclid) {
      // console.log(self.$route.query.fbclid);
      // console.log("save click in cookies");
      setWithExpiry("fbclid", self.$route.query.fbclid, 4000000);
    }
    if (self.$route.query.gclid || self.$route.query.wbraid) {
      console.log(self.$route.query.gclid);
      console.log("save gclid in cookies");
      setWithExpiry("gclid", self.$route.query.gclid, 4000000);
    }
    if (self.$route.query.ttclid) {
      setWithExpiry("ttclid", self.$route.query.ttclid, 4000000);
    }
    if (self.$route.query.utm_source && self.$route.query.utm_source === 'leaddyno' &&  self.$route.query.utm_campaign) {
    console.log('lead dyno!!')
      // utm_source=leaddyno
      // utm_campaign=realmoneylending-TestJose
      let parts = self.$route.query.utm_campaign.split('-');
      // Access the first part of the array
      if(parts && parts[0]){
        self.affil = parts[0];
        console.log('self.affil: '+ self.affil);
        if(self.affil =='realmoneylending'){
          console.log('realmoneylending')
          // LeadDyno.key = "48d3e4e1b8170c3274eadd4256f85d7b4d64239a";
          LeadDyno.recordVisit(); 
          LeadDyno.autoWatch();
        }
        if(self.affil =='elevatorfunding'){
          console.log('elevatorfunding')
          // LeadDyno.key = "252b82ba9b70e948dd02b07030259ea387ec1991";
          LeadDyno.recordVisit(); 
          LeadDyno.autoWatch();
        }
        console.log('leadDyno sent')
      }
    }
    if (self.$route.params.provider) {
      self.affil = self.$route.params.provider;
    }

    if (self.$route.query.utm_marketing_cloud_campaign) {
      self.marketing_cloud_campaign =
        self.$route.query.utm_marketing_cloud_campaign;
      setWithExpiry(
        "marketing_cloud_campaign",
        self.$route.query.utm_marketing_cloud_campaign,
        4000000
      );
    }

    let c = document.cookie.split("; ");
    // console.log(c)
    let cookies = {};

    for (let i = c.length - 1; i >= 0; i--) {
      let C = c[i].split("=");
      cookies[C[0]] = C[1];
    }
    let fbp = cookies["_fbp"];
    if (fbp) {
      setWithExpiry("_fbp", fbp, 4000000);
    }

    const leadId = getWithExpiry("leadid");

    // self.modal_reminder.show = true;
    // figure out what page we were on
    // console.log(self.$route.query);
    if (
      self.$route.query &&
      self.$route.query.oauth_state_id &&
      self.$route.query.oauth_state_id !== ""
    ) {
      setWithExpiry(
        "oauth_state_id",
        self.$route.query.oauth_state_id,
        4000000
      );
    }

    if (leadId || self.$route.params.code) {
      self.loading = true;
      self.model.sfleadid = self.$route.params.code
        ? self.$route.params.code
        : leadId;
      self.modal.show = true;
      self.modal.html =
        "<h2>Welcome back!</h2><p>We're loading your application so you can pick up where you left off.</p> <a class='button is-link is-loading is-large is-fullwidth'>Loading</a>";
      // figure out what page we were on

      let oauth_token = getWithExpiry("oauth_state_id");
      console.log("oauth token:" + oauth_token);
      if (oauth_token && oauth_token !== "") {
        console.log("found oauth in ApplyIFF ");
        //when we have oauth token the user came from a redirection from the bank website
        self.modal.show = false;
        self.loading = false;
      }
      $.ajax({
        type: "POST",
        url: "/api/apply/load-progress",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ leadid: self.model.sfleadid }),
      })
        .done(function (response) {
          //self.$route.query.oauth_state_id
          //if page = page + 1
          self.loading = false;
          console.log(" response.page: " + response.page);
          if (response.page && oauth_token && oauth_token !== "") {
            console.log("found oauth in ApplyIFF ");
            //when we have oauth token the user came from a redirection from the bank website
            self.page = response.page;

            console.log(" self.page: " + self.page);
          } else if (response.page) {
            self.page = response.page;
          }
          if (response.appdata) {
            self.model.business = {};
            self.model.business.address = response.appdata.address;
            self.model.business.name = response.appdata.name;
            self.model.business.state = response.appdata.state;
            self.model.business.monthly_sales = response.appdata.monthly_sales;
            if (
              response.appdata.monthly_sales &&
              response.appdata.monthly_sales !== undefined
            ) {
              setWithExpiry(
                "monthly_sales",
                response.appdata.monthly_sales,
                8000000
              );
            }
            self.modal.html =
              "<h2>We found your application for " +
              self.model.business.name +
              "!</h2><p><a href='#' id='resetProgressButton'>Click here</a> to start a new application instead.</p> <a class='button is-link is-loading is-large is-fullwidth'>Loading</a>";

            setTimeout(() => {
              document
                .getElementById("resetProgressButton")
                .addEventListener("click", resetProgress, false);
            }, 500);
          }
          setTimeout(() => {
            self.modal.show = false;
          }, 5000);
        })
        .fail(function (err) {
          console.log(err.responseText);
          alert(err.responseText);
          self.invalid = true;
          self.loading = false;
          self.modal.show = false;
          self.page = 12;
        });
    }
    //this was redirecting to an empty url
    // if (self.$route.params) {
    //   if (self.prod) self.$router.replace({ path: `/apply/` });
    // }

    // window.addEventListener("beforeunload", function (e) {
    //   e.preventDefault();
    //   e.returnValue = "";
    // });

    // var cancel = setInterval(function () {
    //   console.log("counting2: " + self.seconds_elapsed);
    //   self.seconds_elapsed += 1;
    //   if (self.seconds_elapsed >= 5) {
    //     self.modal_reminder.show = true;
    //   }
    // }, 1000);
  },
  watch: {
    page: function (newValue, oldValue) {
      console.log("Old vaule: " + oldValue);
      console.log("Current vaule: " + newValue);
      if (newValue == 5 || newValue == 7) {
        $("#transition_container").css("max-width", "100%");
      } else {
        $("#transition_container").css("max-width", 600);
      }
    },
    // $data: {
    //   handler: function (newValue) {
    //     console.log("Current vaules: " + newValue.page);
    //     if (newValue.page == 3 || newValue.page == 5) {
    //       $("#transition_container").css("max-width", "100%");
    //     } else {
    //       $("#transition_container").css("max-width", 600);
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-workingcapital {
  background-color: #2b286b;
  z-index: 2;
}
.navbar-elevator,.navbar-elevatorfunding,.navbar-elevatorfundingsite, .navbar-meltzerfunding {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-elevator .navbar-item,.navbar-elevatorfunding .navbar-item, .navbar-elevatorfundingsite .navbar-item, .navbar-meltzerfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-drivenfunding,.navbar-drivenfundingsite {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-drivenfunding .navbar-item,.navbar-drivenfundingsite .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-spoffordfunding {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-spoffordfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-tscfunding {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-tscfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-croakfundingpartners {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-croakfundingpartners .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-iconindustriesfunding {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-iconindustriesfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-smtffranchising {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-smtffranchising .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-saloncapitalfunding {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-saloncapitalfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-realmoneylending {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-realmoneylending .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}

.navbar-recessionproofcapital {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-recessionproofcapital .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-digitalsocialhour {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-digitalsocialhour .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
}
.navbar-easypay {
  background-color: #1f5577;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 769px), print {
  .mobile-only {
    display: none;
  }
  #appcontainer {
    margin-left: 0px;
    margin-right: 0px;
  }
  .fullheight {
    /* min-height: 100vh; */
    /* height: 100vh; */
    height: 100%;
  }
  #app-column {
    padding: 20px 100px;
  }
  .tabs a {
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column {
    min-height: 100vh;
  }
  .fixed-tabs {
    position: fixed;
    z-index: 2;
    background: white;
    top: 0px;
    width: 100%;
    left: 0px;
    transition: all 0.3s;
  }
  .pushed-pages {
    margin-top: 55px !important;
  }
}

.is-active {
  font-weight: bold;
}

#cardiff-column {
  /* background: #f1f1f1; */
  background: linear-gradient(
    90deg,
    rgb(246, 246, 246) 0%,
    rgb(242, 242, 242) 57%,
    rgb(237, 237, 237) 100%
  );
  z-index: 1;
  padding-top: 50px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}

#stagingmenu {
  position: fixed;
  width: 100%;
  bottom: 0;
  background: #ecf3ff;
  opacity: 0.3;
  z-index: 1;
  transition: all 0.3s;
}

#stagingmenu:hover {
  opacity: 1;
}

.listpage {
  margin-top: 0px;
}
.listpage-active {
  margin-top: 0px;
  font-weight: bold;
}
</style>
